import { graphql } from "@/gql"
import { MyJobsClosedJobPostsQueryDocument } from "@/gql/graphql"
import { useQuery } from "@apollo/client"
import { ClosedJobsMobile } from "./ClosedJobsMobile"
import { ClosedJobsTable } from "./ClosedJobsTable"
import { useRef } from "react"
import { useHandleListEndReached } from "@/hooks/useHandleListEndReached"
import { Spinner } from "@/elements"

graphql(`
  query MyJobsClosedJobPostsQuery(
    $first: Int
    $after: String
    $isCreative: Boolean = false
    $isClient: Boolean = false
  ) {
    currentUser {
      id
      __typename
      creative @include(if: $isCreative) {
        __typename
        id
        jobPostings(status: CLOSED, first: $first, after: $after) {
          totalCount
          pageInfo {
            hasNextPage
            endCursor
          }
          edges {
            cursor
            node {
              id
              ...ClosedJobPosting
            }
          }
        }
      }

      client @include(if: $isClient) {
        __typename
        id
        jobPostings(status: CLOSED, first: $first, after: $after) {
          edges {
            cursor
            node {
              id
              ...ClosedJobPosting
            }
          }
          totalCount
          pageInfo {
            hasNextPage
            endCursor
          }
        }
      }
    }
  }
`)

graphql(`
  fragment ClosedJobPosting on JobPosting {
    id
    title
    createdAt
    locationName
    payString
    startDate
    datesAreFlexible
    closedAt
    position {
      id
      name
    }
    creativeWorkType {
      id
      name
    }
    ...JobTitleColorised
    applicationCount
    status
  }
`)

interface Props {
  currentUserField: "client" | "creative"
}

const PAGE_SIZE = 20
export const ClosedJobs: React.FC<Props> = props => {
  const { data, loading, networkStatus, fetchMore } = useQuery(MyJobsClosedJobPostsQueryDocument, {
    variables: {
      first: PAGE_SIZE,
      after: null,
      isCreative: props.currentUserField === "creative",
      isClient: props.currentUserField === "client",
    },
  })

  const loadMoreRef = useRef(null)
  useHandleListEndReached({
    pageInfo: data?.currentUser?.[props.currentUserField]?.jobPostings.pageInfo,
    first: PAGE_SIZE,
    fetchMore,
    networkStatus,
    observerRef: loadMoreRef,
  })
  return (
    <>
      <ClosedJobsTable data={data} loading={loading} currentUserField={props.currentUserField} />
      <ClosedJobsMobile data={data} loading={loading} currentUserField={props.currentUserField} />
      <div className="relative mb-1 mt-2 flex h-[20px] w-full flex-row items-center justify-center" ref={loadMoreRef}>
        {data?.currentUser?.[props.currentUserField]?.jobPostings?.pageInfo?.hasNextPage && <Spinner size="medium" />}
      </div>
    </>
  )
}
